<idp-search-modal-icon
  (openFlyout)="openFlyoutSearch()"
  (analyticsEvent)="analyticsEventTracking($event)"
></idp-search-modal-icon>

<!-- Desktop Dialog (>=768px) -->
@if (show && showModal === 'desktop') {
<dialog
  id="search-popup"
  class="pop-up"
  aria-labelledby="flyout-search-header"
  aria-describedby="flyout-search-description"
  aria-modal="true"
  role="dialog"
  #flyoutSearchDesktop
>
  <div
    [ngClass]="{
      'laptop:!max-h-[calc(100dvh-200px)]': isAlertAdvisory,
      'laptop:!max-h-[calc(100dvh-100px)]': !isAlertAdvisory
    }"
    class="pop-up-box !pt-0 pl-32 pr-16"
    idpFlyoutPosition
  >
    <div
      class="pop-up-box-header flex items-center !justify-end border-none min-w-[327px] !p-0"
      id="mach-core-search-desktop-header"
    >
      <svg
        width="80"
        height="64"
        viewBox="0 0 80 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_18482_46281"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="-8"
          width="80"
          height="72"
        >
          <rect y="-8" width="79.2453" height="72" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0_18482_46281)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M78.2057 -8.01135L62.0235 14.7275L43.997 14.815L57.1839 1.78898L78.2057 -8.01135Z"
            fill="#E01933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.1016 36.1808L22.5412 29.1015L26.9955 21.137L37.305 19.2447L34.1016 36.1808Z"
            fill="#E01933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.0621 14.8803L49.2343 58.1151L78.3127 -7.98438L44.0621 14.8803Z"
            fill="#991933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.5555 29.1348L45.017 64.681L37.3545 19.2578L22.5555 29.1348Z"
            fill="#991933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M78.1606 -8.15473L7.58616 -7.73853L43.909 14.7105L78.1606 -8.15473Z"
            fill="#E01933"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.00128355 -6.49024L22.4622 29.0552L37.2613 19.1782L0.00128355 -6.49024Z"
            fill="#E01933"
          />
        </g>
      </svg>

      <button
        class="pop-up-box-header-close-button"
        (click)="closeFlyout()"
        aria-label="Close pop-up"
        id="mach-core-search-desktop-close"
      >
        <div class="pop-up-box-header-close-button-icon"></div>
      </button>
    </div>
    <div class="pop-up-box-content pt-8 mt-0">
      <div class="flex flex-col px-8">
        @if ((flyoutSearch$ | ngrxPush) || true) {
        <idp-flyout-search-wrapper
          (closeFlyoutSearch)="closeFlyout()"
          [displayFlyout]="(flyoutSearch$ | ngrxPush) || true"
          [displayFooterSearch]="displaySearchFooter"
          inputFieldId="site-search-input-desktop"
        ></idp-flyout-search-wrapper>
        }
      </div>
    </div>
  </div>
  <form method="dialog" class="pop-up-backdrop">
    <button (click)="closeFlyout()" aria-label="Close pop-up">Close</button>
  </form>
</dialog>
}

<!-- Mobile Dialog (<768px) -->
@if (show && showModal === 'mobile') {
<dialog
  id="search-mobile-popup"
  class="general-modal !p-0"
  aria-labelledby="flyout-search-header"
  aria-describedby="flyout-search-description"
  aria-modal="true"
  role="dialog"
  #flyoutSearchMobile
>
  <div class="general-modal-box ml-auto w-full !h-[100dvh]">
    <div
      class="general-modal-header flex items-center justify-end"
      id="mach-core-search-mobile-header"
    >
      <button
        class="general-modal-close-button"
        (click)="closeFlyout()"
        aria-label="Close modal"
        id="mach-core-search-mobile-close"
      ></button>
    </div>
    <div class="general-modal-content !px-32 !pt-0">
      <div class="flex items-center !justify-end border-none mb-8">
        <svg
          width="80"
          height="64"
          viewBox="0 0 80 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_18482_46281"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="-8"
            width="80"
            height="72"
          >
            <rect y="-8" width="79.2453" height="72" fill="#C4C4C4" />
          </mask>
          <g mask="url(#mask0_18482_46281)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M78.2057 -8.01135L62.0235 14.7275L43.997 14.815L57.1839 1.78898L78.2057 -8.01135Z"
              fill="#E01933"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M34.1016 36.1808L22.5412 29.1015L26.9955 21.137L37.305 19.2447L34.1016 36.1808Z"
              fill="#E01933"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.0621 14.8803L49.2343 58.1151L78.3127 -7.98438L44.0621 14.8803Z"
              fill="#991933"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.5555 29.1348L45.017 64.681L37.3545 19.2578L22.5555 29.1348Z"
              fill="#991933"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M78.1606 -8.15473L7.58616 -7.73853L43.909 14.7105L78.1606 -8.15473Z"
              fill="#E01933"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.00128355 -6.49024L22.4622 29.0552L37.2613 19.1782L0.00128355 -6.49024Z"
              fill="#E01933"
            />
          </g>
        </svg>
      </div>
      @if ((flyoutSearch$ | ngrxPush) || true) {
      <idp-flyout-search-wrapper
        (closeFlyoutSearch)="closeFlyout()"
        [displayFlyout]="(flyoutSearch$ | ngrxPush) || true"
        [displayFooterSearch]="displaySearchFooter"
        inputFieldId="site-search-input-mobile"
      ></idp-flyout-search-wrapper>
      }
    </div>
  </div>
  <form method="dialog" class="general-modal-backdrop">
    <button (click)="closeFlyout()" aria-label="Close modal">Close</button>
  </form>
</dialog>
}
